"use strict";module.exports = {
  _K_: new WeakMap(),
  _J_: new WeakMap(),
  _o_: new WeakMap(),
  aU_: new WeakMap(),
  _m_: new WeakMap(),
  _n_: {}
};